import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _intersectionObserver from "intersection-observer";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

// @ts-nocheck
import { Platform } from 'react-native';
import { TRACKING_OPERATION } from '../tracking/constants';
import { dataMaintainer } from '../../components/ConfigProvider/rn/context';
var module = {
  exports: {}
};
var exports = module.exports;
var reportImpression = function reportImpression(_ref) {
  var _dataMaintainer$track;
  var _ref$trackingsection = _ref.trackingsection,
    trackingsection = _ref$trackingsection === void 0 ? '' : _ref$trackingsection,
    _ref$trackingtarget = _ref.trackingtarget,
    trackingtarget = _ref$trackingtarget === void 0 ? '' : _ref$trackingtarget,
    _ref$trackingdata = _ref.trackingdata,
    trackingdata = _ref$trackingdata === void 0 ? '' : _ref$trackingdata;
  if (trackingdata) {
    try {
      if (typeof trackingdata === 'string') {
        trackingdata = JSON.parse(trackingdata);
      }
    } catch (error) {
      trackingdata = {};
    }
  } else {
    trackingdata = {};
  }
  (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : _dataMaintainer$track.dispatchTrack({
    operation: TRACKING_OPERATION.IMPRESSION,
    section: trackingsection,
    target: trackingtarget,
    data: {
      viewed_objects: [
      // impression 统一补充
      _objectSpread({}, trackingdata)]
    }
  });
};
var handleIo;
if (Platform.OS === 'web') {
  _intersectionObserver;
  var viewTimerList = {};
  var io = new IntersectionObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      var _loop = function _loop() {
        var entry = _step.value;
        var _entry$target$dataset = entry.target.dataset.trackingkey,
          trackingkey = _entry$target$dataset === void 0 ? '' : _entry$target$dataset;
        if (viewTimerList[trackingkey]) {
          clearTimeout(viewTimerList[trackingkey]);
          viewTimerList[trackingkey] = null;
        }
        if (entry.intersectionRatio > 0.5) {
          viewTimerList[trackingkey] = setTimeout(function () {
            var trackingValue = dataMaintainer.getTrackerMap(trackingkey);
            if (trackingValue != null) {
              reportImpression(trackingValue);
            }
          }, 1001); // 超过1s上报
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    threshold: [0.5]
  });
  handleIo = function handleIo(ref, func) {
    if (Array.isArray(ref)) {
      ref.forEach(function (element, i) {
        try {
          var target = element;
          if (Array.isArray(target)) {
            io[func](target[0]);
          } else {
            io[func](target);
          }
        } catch (err) {
          console.error(err);
        }
      });
    } else {
      try {
        io[func](ref);
      } catch (err) {
        console.error(err);
      }
    }
  };
}
export var addObserver = function addObserver(ref) {
  var _handleIo;
  (_handleIo = handleIo) === null || _handleIo === void 0 ? void 0 : _handleIo(ref, 'observe');
};
export var removeObserver = function removeObserver(ref) {
  var _handleIo2;
  (_handleIo2 = handleIo) === null || _handleIo2 === void 0 ? void 0 : _handleIo2(ref, 'unobserve');
};
export default module.exports;